<template>
  <div class="message-storage-container scrollbar px-2">
    <div
      v-for="(file, index) in messages"
      :key="index"
      class="z2-file-container pointer"
      @click.stop.prevent="selectMessage(file)">
      <div class="d-flex align-items-center">
        <el-checkbox
          v-if="selectMulti"
          class="me-1"
          :value="file.select"></el-checkbox>
        <ChatFileV3
          v-if="file.msgType == 'share.file'"
          :ref="'chatFileV3' + index.toString()"
          :file="file"
          :account-id="conversation.accountId"
          :message-id="file.id"
          :preventDownload="selectMulti"
          :message-ts="file.ts" />
      </div>
      <!-- <div
        class="btn-forward-file pointer"
        @click.stop.prevent="shareFile(file)">
        <IconV2
          name="v2-share"
          color="#3484F0" />
      </div> -->
    </div>
    <div v-if="messages.length >= round * 40" style="display: flex; justify-content: center; align-items: center;" @click="loadMoreImage">
      <el-button class="justify-content-between align-items-center" size="small">Tải thêm</el-button>
    </div>
    <div
      v-if="selectedMessages.length"
      class="px-12 d-flex flex-1 align-items-center justify-content-between border-top"
      style="width: 300px; z-index: 999; position: fixed; bottom: 0; height: 48px; background-color: white">
      <span class="font-14 text-grey600">Đã chọn: {{ selectedMessages.length }}</span>
      <div class="d-flex align-items-center">
        <!-- <div class="z2-btn-status-off z2-btn-circle-small me-2">
          <IconV2 name="v2-image" />
        </div> -->
        <div
          @click="downloadMessage"
          class="z2-btn-status-off z2-btn-circle-small me-2">
          <IconV2 name="v2-import" />
        </div>
        <div
          @click="forwardMultiMessage"
          class="z2-btn-status-off z2-btn-circle-small">
          <IconV2 name="v2-share" />
        </div>
        <el-divider
          direction="vertical"
          class="p-0" />
        <div
          @click="deleteMessage"
          class="z2-btn-status-off z2-btn-circle-small">
          <IconV2
            name="icon-trash"
            color="#CF4343" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { COMMON } from "../lib/Common";
import ChatFileV3 from "./message/ChatFileV3";

export default {
  components: { ChatFileV3 },
  data() {
    return {
      round: 1,
    };
  },
  props: ["messages", "conversation", "selectMulti"],
  computed: {
    selectedMessages() {
      return this.messages.filter((mess) => mess.select);
    },
  },
  methods: {
    selectMessage(img) {
      this.$set(img, "select", !img.select);
    },
    resetSelect() {
      this.messages.forEach((mess) => {
        this.$set(mess, "select", false);
      });
    },
    shareFile() {

    },
    downloadMessage() {
      this.messages.forEach((mess, index) => {
        if (mess.select) {
          const key = "chatFileV3" + index.toString();
          this.$refs[key][0].downloadFile();
        }
      });
      this.$emit("reset");
      this.resetSelect();
    },
    forwardMultiMessage() {
      const data = {
        messages: this.selectedMessages.map(m => m),
        isArray: true,
        type: COMMON.CHAT_FILE
      };
      this.$bus.$emit("forwardMessageMulti", data);
      this.resetSelect();
      this.$emit("reset");
    },
    deleteMessage() {
      this.selectedMessages.forEach((message) => {
        let request = {
          accountId: this.conversation.accountId,
          toId: this.conversation.toId,
          group: this.conversation.group,
          cliMsgId: message.cliMsgId,
          globalMsgId: message.id.msgId,
          ownerId: this.conversation.toId,
          destId: this.conversation.toId,
        };
        this.$http.post("/api/message/delete", request);
      });
      this.resetSelect();
      this.$emit("reset");
    },
    loadMoreImage() {
      this.round += 1;
      this.$emit('loadMoreImg', this.round);
    }
  },
};
</script>

<style lang="scss" scoped>
.message-storage-container {
  height: calc(100vh - 125px) !important;
  overflow-y: auto;
}
.z2-file-container {
  position: relative;
  .btn-forward {
    right: 6px;
  }
  .btn-forward-file {
    display: none;
    position: absolute;
    background-color: #f4f5f9;
    top: 16px;
    right: 6px;
    padding: 1px;
    border-radius: 4px;
  }
}

.z2-file-container:hover {
  .btn-forward-file {
    display: block;
  }
}
</style>